import { Controller, useFormContext } from "react-hook-form";

import { NcSelect, NcSelectProps } from "./nc-select";

export interface NcFormSelectProps
  extends Omit<NcSelectProps, "name" | "validate" | "onBlur" | "value" | "validationBehavior"> {
  name: string; // Was optional in NcSelectProps and is now required
}

export const NcFormSelect = ({ name, onChange, ...props }: NcFormSelectProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: onFieldChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcSelect
          name={name}
          value={value ? value : ""}
          onChange={key => {
            onChange?.(key);
            const value = key || undefined;
            onFieldChange(value);
          }}
          onBlur={onBlur}
          validationBehavior="aria"
          isInvalid={invalid}
          error={error}
          ref={ref}
          {...props}
        />
      )}
    />
  );
};
